import { render, staticRenderFns } from "./SortIcon.vue?vue&type=template&id=4395d39e&scoped=true&"
import script from "./SortIcon.vue?vue&type=script&lang=ts&"
export * from "./SortIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4395d39e",
  null
  
)

export default component.exports